import {Component, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GnFormItem} from '../json-form/json-form-item/FormItem';
import {pipeTypes} from 'geminis-ng-core';

@Component({
  selector: 'gn-label',
  template: `{{value}}`,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GnLabelComponent),
    multi: true
  }]
})
@GnFormItem('label')
export class GnLabelComponent implements ControlValueAccessor {

  value: string;
  pipe: string;
  pipeOptions: any[] = [];

  registerOnChange(fn: any): void {
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    if (obj) {
      this.value = this.pipe ? pipeTypes[this.pipe].transform(obj, ...this.pipeOptions) : obj;
    }
  }

}
